import type { Provider, ProviderIos } from "./ports";

class Service {
  private readonly provider: Provider;

  constructor(provider: Provider) {
    this.provider = provider;
  }

  create(params: ProviderIos.Create.In) {
    return this.provider.create(params);
  }

  update(params: ProviderIos.Update.In) {
    return this.provider.update(params);
  }

  delete(params: ProviderIos.Delete.In) {
    return this.provider.delete(params);
  }

  approve(params: ProviderIos.Approve.In) {
    return this.provider.approve(params);
  }

  get(params: ProviderIos.Get.In) {
    return this.provider.get(params);
  }

  getForAdmin(params: ProviderIos.Get.In) {
    return this.provider.getForAdmin(params);
  }

  getPaginated(params: ProviderIos.GetPaginated.In) {
    return this.provider.getPaginated(params);
  }

  getPaginatedForAdmin(params: ProviderIos.GetPaginatedForAdmin.In) {
    return this.provider.getPaginatedForAdmin(params);
  }

  getByOrder(params: ProviderIos.GetByOrder.In) {
    return this.provider.getByOrder(params);
  }
}

export { Service };
